import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  TextField,
  Button,
  Grid,
  Container,
  CircularProgress,
  Autocomplete,
} from "@mui/material";

import TabletIcon from "../../../Assets/Icons/tablet-icon.png";
import { useNotification } from "../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";
import httpclient from "../../../Utils";
import { useFakeCustomer } from "./useFakeCustomer";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const customerInitialFields = {
  customerNo: "",
};

function AddFakeCustomer() {
  const [tabIndex, setTabIndex] = useState(0);

  const [customerInfo, setCustomerInfo] = useState(customerInitialFields);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();

  const { customerCodes } = useFakeCustomer();

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const validateForm = () => {
    const rules = [
      {
        condition: !customerInfo.customerNo,
        message: "Customer No is required",
      },
    ];

    for (const rule of rules) {
      if (rule.condition) {
        showNotification("error", rule.message);
        return false;
      }
    }
    return true;
  };

  const getFormattedData = (data) => {
    const formData = new FormData();

    const dataMap = {
      customer_no: data.customerNo,
    };

    Object.entries(dataMap).forEach(([key, value]) => {
      formData.append(key, value);
    });

    return formData;
  };

  const handleAdd = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    const endpoint = "/fake-customer";

    const customerData = getFormattedData(customerInfo);

    try {
      setIsSubmitting(true);

      const res = await httpclient.post(endpoint, customerData);

      const { data } = res;

      if (data.status === 200) {
        showNotification("success", data.message);

        navigate("/fake-customer");
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      handleApiError(error, setIsSubmitting);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setCustomerInfo(customerInitialFields);

    setTimeout(() => {
      navigate("/fake-customer");
    }, 100);
  };

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ overflow: "hidden" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            aria-label="fake customer detail tabs"
          >
            <Tab
              icon={<img src={TabletIcon} alt="Tablet icon" />}
              iconPosition="start"
              label="Fake Customer Detail"
              id="tab-0"
              aria-controls="tabpanel-0"
              sx={{
                "&.Mui-selected": { color: "#7152F3" },
              }}
            />
          </Tabs>
        </Box>

        <TabPanel value={tabIndex} index={0}>
          <Box component="form" onSubmit={handleAdd} noValidate>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  disablePortal
                  options={customerCodes || []}
                  getOptionLabel={(option) => option.customer_no?.trim() || ""} // fix key name + trim spaces
                  value={
                    (customerCodes &&
                      customerCodes.find(
                        (item) =>
                          item.customer_no.trim() ===
                          customerInfo.customerNo.trim()
                      )) ||
                    null
                  }
                  sx={{ width: "100%" }}
                  onChange={(event, newValue) => {
                    setCustomerInfo({
                      ...customerInfo,
                      customerNo: newValue ? newValue.customer_no.trim() : "",
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Customer No"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
              >
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{ mr: 2, textTransform: "none" }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ backgroundColor: "#7152F3", textTransform: "none" }}
                  disabled={isSubmitting}
                >
                  {isSubmitting && (
                    <CircularProgress size={24} sx={{ mr: 1 }} />
                  )}
                  {isSubmitting ? "Adding..." : "Add"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </TabPanel>
      </Paper>
    </Container>
  );
}

export default AddFakeCustomer;
